import { isDefined } from 'aem-libs-ts/src/utils/common/isDefined'

export const createTestId = (...ids: string[]) => ids.filter(isDefined).join('--')
